module.exports = __webpack_public_path__ + "static/fonts/ef-picto.261cf0e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ef-picto.ttf?g697my
// module id = 668
// module chunks = 42